import React, { useEffect } from 'react';
import { ScrollReveal } from '../components/ScrollReveal';
import { useSEO } from '../utils/seo';
export const MentionsLegales = () => {
  useSEO({
    title: 'Mentions Légales | Dispel Your Tattoo',
    description: 'Mentions légales du site Dispel Your Tattoo, studio de détatouage laser à Martigny, Valais.',
    canonical: 'https://www.dispelyourtattoo.ch/mentions-legales'
  });
  return <main className="pt-32 pb-24" data-id="element-920">
      <div className="max-w-[800px] mx-auto px-6 md:px-12" data-id="element-921">
        <ScrollReveal data-id="element-922">
          <h1 className="text-4xl md:text-5xl font-medium text-brand-light mb-12 tracking-tight" data-id="element-923">
            Mentions légales
          </h1>
        </ScrollReveal>

        <div className="space-y-10 text-brand-gray font-light leading-[1.85] text-base md:text-lg" data-id="element-924">
          <ScrollReveal delay={0.1} data-id="element-925">
            <section data-id="element-926">
              <h2 className="text-xl font-medium text-brand-light mb-4" data-id="element-927">
                1. Éditeur du site
              </h2>
              <p data-id="element-928">
                Le site{' '}
                <strong className="text-brand-light" data-id="element-929">
                  www.dispelyourtattoo.ch
                </strong>{' '}
                est édité par :
              </p>
              <ul className="mt-4 space-y-1" data-id="element-930">
                <li data-id="element-931">
                  <strong className="text-brand-light" data-id="element-932">Raison sociale :</strong>{' '}
                  Dispel Your Tattoo
                </li>
                <li data-id="element-933">
                  <strong className="text-brand-light" data-id="element-934">Activité :</strong>{' '}
                  Détatouage laser professionnel
                </li>
                <li data-id="element-935">
                  <strong className="text-brand-light" data-id="element-936">Adresse :</strong> Rue de
                  la Délèze 2, 1920 Martigny, Suisse
                </li>
                <li data-id="element-937">
                  <strong className="text-brand-light" data-id="element-938">Email :</strong>{' '}
                  dispeltattoo@gmail.com
                </li>
                <li data-id="element-939">
                  <strong className="text-brand-light" data-id="element-940">Téléphone :</strong> 079
                  102 69 45
                </li>
              </ul>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.15} data-id="element-941">
            <section data-id="element-942">
              <h2 className="text-xl font-bold text-brand-light mb-4" data-id="element-943">
                2. Hébergement
              </h2>
              <p data-id="element-944">
                Le site est hébergé par des prestataires tiers. Les informations
                relatives à l'hébergeur sont disponibles sur demande auprès de
                l'éditeur du site.
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.2} data-id="element-945">
            <section data-id="element-946">
              <h2 className="text-xl font-bold text-brand-light mb-4" data-id="element-947">
                3. Propriété intellectuelle
              </h2>
              <p data-id="element-948">
                L'ensemble du contenu du site www.dispelyourtattoo.ch (textes,
                images, photographies, logos, vidéos, éléments graphiques,
                structure) est protégé par le droit d'auteur et les lois suisses
                relatives à la propriété intellectuelle.
              </p>
              <p className="mt-4" data-id="element-949">
                Toute reproduction, représentation, modification, publication ou
                adaptation de tout ou partie des éléments du site, quel que soit
                le moyen ou le procédé utilisé, est interdite sans
                l'autorisation écrite préalable de Dispel Your Tattoo.
              </p>
              <p className="mt-4" data-id="element-950">
                Les photographies présentes sur le site sont la propriété
                exclusive de Dispel Your Tattoo ou sont utilisées avec
                l'autorisation de leurs auteurs respectifs. Toute utilisation
                non autorisée constitue une contrefaçon.
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.25} data-id="element-951">
            <section data-id="element-952">
              <h2 className="text-xl font-bold text-brand-light mb-4" data-id="element-953">
                4. Responsabilité
              </h2>
              <p data-id="element-954">
                Dispel Your Tattoo s'efforce de fournir des informations aussi
                précises que possible sur le site. Toutefois, l'éditeur ne
                saurait être tenu responsable des omissions, inexactitudes ou
                carences dans la mise à jour des informations, qu'elles soient
                de son fait ou du fait de tiers partenaires.
              </p>
              <p className="mt-4" data-id="element-955">
                Les informations présentes sur le site sont fournies à titre
                indicatif et ne constituent en aucun cas un avis médical. Chaque
                traitement de détatouage fait l'objet d'une consultation
                personnalisée préalable.
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.3} data-id="element-956">
            <section data-id="element-957">
              <h2 className="text-xl font-bold text-brand-light mb-4" data-id="element-958">
                5. Liens hypertextes
              </h2>
              <p data-id="element-959">
                Le site peut contenir des liens vers d'autres sites internet.
                Dispel Your Tattoo ne dispose d'aucun contrôle sur le contenu de
                ces sites tiers et décline toute responsabilité quant à leur
                contenu ou aux éventuels dommages résultant de leur
                consultation.
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.35} data-id="element-960">
            <section data-id="element-961">
              <h2 className="text-xl font-bold text-brand-light mb-4" data-id="element-962">
                6. Droit applicable
              </h2>
              <p data-id="element-963">
                Les présentes mentions légales sont régies par le droit suisse.
                En cas de litige, les tribunaux compétents du canton du Valais
                seront seuls compétents.
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.4} data-id="element-964">
            <section data-id="element-965">
              <h2 className="text-xl font-bold text-brand-light mb-4" data-id="element-966">
                7. Contact
              </h2>
              <p data-id="element-967">
                Pour toute question relative aux présentes mentions légales,
                vous pouvez nous contacter à l'adresse suivante :{' '}
                <a href="mailto:dispeltattoo@gmail.com" className="text-brand-light underline hover:text-white transition-colors" data-id="element-968">
                  dispeltattoo@gmail.com
                </a>
                .
              </p>
            </section>
          </ScrollReveal>
        </div>
      </div>
    </main>;
};